module.exports = __webpack_public_path__ + "static/media/logo.f8385f67.svg";